import { readable, writable } from "svelte/store";
import { NotificationService } from "./NotificationService";
import { Account } from "./Account";
import { AlphaVantageClient } from "./AlphaVantageClient";
export const inputAccount = writable(new Account());
export const outputAccount = writable(null);
export const alphaVantageClient = writable(new AlphaVantageClient());
export const notificationService = readable(new NotificationService(), function start(set) { return function stop() { }; });
export const notifications = writable([]);
export const numberFormatter = readable(new Intl.NumberFormat('en-US', { style: 'decimal' }), function start(set) { return function stop() { }; });
export const currencyFormatter = readable(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }), function start(set) { return function stop() { }; });
export const percentFormatter = readable(new Intl.NumberFormat('en-US', { style: 'percent' }), function start(set) { return function stop() { }; });
